import { CustomTable } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventMachineSaleProductReport } from '@/model/EventMachineSaleProductReport';
import React, { Fragment } from 'react';
import { Card } from 'reactstrap';

interface StateProps {
  machines: EventMachineSaleProductReport[];
}

export const SaleProductMachineContent: React.FC<StateProps> = ({ machines }): JSX.Element => (
  <Fragment>
    <h6 className="mb-4 collapseTableText">Vendas de produtos por Maquininha</h6>
    <hr />
    {machines.map(data => (
      <Fragment key={data.id}>
        <h6 className="mb-4 mt-5 collapseTableText">{data.serialNumber}</h6>
        <Card
          className="mb-5 card-no-border customTableScroll"
          style={{ border: 'none', overflow: 'auto' }}
        >
          {data.categories.map(category => (
            <Fragment key={category.id}>
              <h6 className="collapseTableText">{category.name}</h6>
              <div className="p-4">
                <CustomTable
                  theme="secondary"
                  numberRowsPerPage={0}
                  progressPending={false}
                  columns={[
                    {
                      name: 'Produto',
                      selector: row => row.productName,
                    },
                    {
                      name: 'Vendidos',
                      selector: row => row.productSold,
                    } /*
                    {
                      name: 'Estoque inicial',
                      selector: row => row.initialInventory,
                    },
                    {
                      name: 'Estoque disponível',
                      selector: row => row.availableStock,
                    }, */,
                    {
                      name: 'Valor',
                      selector: row => row.unitValue,
                    },
                    {
                      name: 'Venda',
                      selector: row => row.totalSaleValue,
                    },
                    {
                      name: 'Comissão',
                      selector: row => row.totalCommission,
                    },
                    {
                      name: 'Venda + Comissão',
                      selector: row => row.totalSaleWithCommission,
                    },
                  ]}
                  data={
                    category.products.map(product => ({
                      productName: product.name,
                      productSold: product.amountSold,
                      // initialInventory: product.initialInventory,
                      // availableStock: product.availableStock,
                      unitValue: toCurrency(product.unitValue),
                      totalSaleValue: toCurrency(product.totalSaleValue),
                      totalCommission: toCurrency(product.totalCommission),
                      totalSaleWithCommission: toCurrency(product.totalSaleWithCommission),
                    })) || []
                  }
                />
              </div>
            </Fragment>
          ))}
          <hr className="mb-0" style={{ minWidth: '1080px' }} />
          <div
            style={{
              padding: '30px 40px',
              gap: '40px',
            }}
            className="d-flex justify-content-center"
          >
            <div className="d-flex">
              <div className="mr-1 text-small-gray-regular">Quantidade:</div>
              <div className="text-small-black-600">{data.summary.amountSold}</div>
            </div>
            {data.summary.courtesies > 0 && (
              <div className="d-flex">
                <div className="mr-1 text-small-gray-regular">Cortesias:</div>
                <div className="text-small-black-600">{data.summary.courtesies}</div>
              </div>
            )}
            {data.summary.discount > 0 && (
              <div className="d-flex">
                <div className="mr-1 text-small-gray-regular">Descontos:</div>
                <div className="text-small-black-600">{toCurrency(data.summary.discount)}</div>
              </div>
            )}
            {data.summary.availableStock > 0 && (
              <div className="d-flex">
                <div className="mr-1 text-small-gray-regular">Estoque disponível:</div>
                <div className="text-small-black-600">{data.summary.availableStock}</div>
              </div>
            )}
            <div className="d-flex">
              <div className="mr-1 text-small-gray-regular">Venda:</div>
              <div className="text-small-black-600">{toCurrency(data.summary.totalSaleValue)}</div>
            </div>
            {data.summary.totalCommission > 0 && (
              <Fragment>
                <div className="d-flex">
                  <div className="mr-1 text-small-gray-regular">Comissão:</div>
                  <div className="text-small-black-600">
                    {toCurrency(data.summary.totalCommission)}
                  </div>
                </div>
                <div className="d-flex">
                  <div className="mr-1 text-small-gray-regular">Venda + Comissão:</div>
                  <div className="text-small-black-600">
                    {toCurrency(data.summary.totalSaleWithCommission)}
                  </div>
                </div>
              </Fragment>
            )}
          </div>
          <div
            style={{
              padding: '30px 40px',
              gap: '40px',
            }}
            className="d-flex justify-content-center"
          >
            <div className="d-flex">
              <div className="mr-1 text-small-gray-regular">Crédito:</div>
              <div className="text-small-black-600">{toCurrency(data.payments.credit)}</div>
            </div>
            <div className="d-flex">
              <div className="mr-1 text-small-gray-regular">Débito:</div>
              <div className="text-small-black-600">{toCurrency(data.payments.debit)}</div>
            </div>
            <div className="d-flex">
              <div className="mr-1 text-small-gray-regular">PIX:</div>
              <div className="text-small-black-600">{toCurrency(data.payments.pix)}</div>
            </div>
            <div className="d-flex">
              <div className="mr-1 text-small-gray-regular">Dinheiro:</div>
              <div className="text-small-black-600">{toCurrency(data.payments.money)}</div>
            </div>
          </div>
        </Card>
      </Fragment>
    ))}
  </Fragment>
);
